'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSpacing = undefined;

var _breakpoint = require('../config/enums/breakpoint');

var _spacings = require('../config/data/spacings');

var getSpacing = exports.getSpacing = function getSpacing(isZero, size, breakpoint) {
    if (size === void 0) {
        size = 'small';
    }
    if (isZero) {
        return 0;
    }
    var spacingKey = Object.keys(_spacings.spacings).find(function (key) {
        return key === size;
    });
    if (!spacingKey) {
        return 0;
    }
    var spacing = _spacings.spacings[spacingKey];
    if (breakpoint === _breakpoint.Breakpoint.WEB) {
        return spacing.web;
    }
    if (breakpoint === _breakpoint.Breakpoint.MOBILE) {
        return spacing.mobile;
    }
    return 0;
};
//# sourceMappingURL=spacings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/helpers/spacings.js
// module id = 1862
// module chunks = 0